<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible', false)"
    :header="$t('features.single_plant_contacts.plant_contact')"
    modal
  >
    <div class="flex flex-col my-1">
      <div class="flex flex-row">
        <div class="w-60 leading-9">
          {{ $t('global.name') }}
        </div>
        <InputText
          v-model="form.name"
          :placeholder="$t('global.name')"
          :invalid="formValidation.name.state"
          autofocus
          class="w-80"
        />
        <small v-if="formValidation.name.state">
          {{ formValidation.name.feedback }}
        </small>
      </div>

      <div class="flex flex-row my-1">
        <div class="w-60 leading-9">{{ $t('global.email') }}</div>
        <InputText
          v-model="form.email"
          :placeholder="$t('global.email')"
          :invalid="formValidation.email.state"
          autofocus
          class="w-80"
        />
        <small v-if="formValidation.email.state">
          {{ formValidation.email.feedback }}
        </small>
      </div>

      <div class="flex flex-row my-1">
        <div class="w-60 leading-9">
          {{ $t('global.phone_number') }}
        </div>
        <InputText
          v-model="form.phone_number"
          :placeholder="$t('global.phone_number')"
          :invalid="formValidation.phone_number.state"
          autofocus
          class="w-80"
        />
        <small v-if="formValidation.phone_number.state">
          {{ formValidation.phone_number.feedback }}
        </small>
      </div>
    </div>
    <form @submit.prevent="submit" style="width: 50rem">
      <div class="flex-auto float-right">
        <Button
          @click="submit"
          class="mb-3"
          variant="primary"
          :disabled="submitDisabled"
        >
          {{ $t('global.create') }}
        </Button>
      </div>
    </form>
  </Dialog>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { PlantContactJson } from '@/data/plants/PlantContactJson.ts';
import PlantContactsApi from '@/data/plants/PlantContactsApi.ts';

export default {
  name: 'PlantContactDialog',
  props: {
    visible: { type: Boolean, required: true },
    companyId: { type: Number, required: true },
    plantId: { type: Number, required: true },
    contact: { type: Object as PropType<PlantContactJson>, required: false },
  },
  data() {
    return {
      form: {
        name: null,
        email: null,
        phone_number: null,
      },
      formValidation: this.getEmptyFormValidation(),
    };
  },
  mounted() {
    this.formValidation = this.getEmptyFormValidation();
  },
  methods: {
    submit() {
      this.formValidation = this.getEmptyFormValidation();
      if (this.contact) {
        this.updateContact();
      } else {
        this.createContact();
      }
    },
    createContact() {
      new PlantContactsApi()
        .store(this.companyId, this.plantId, this.form)
        .then(() => {
          this.$emit('contact-changed');
        })
        .catch(this.handleError);
    },
    updateContact() {
      new PlantContactsApi()
        .update(this.companyId, this.plantId, this.contact.id, this.form)
        .then(() => {
          this.$emit('contact-changed');
        })
        .catch(this.handleError);
    },
    handleError(exception) {
      for (const index in exception.messageBag._messages) {
        this.formValidation[index].state = false;
        this.formValidation[index].feedback =
          exception.messageBag._messages[index][0];
      }
    },
    updateForm() {
      this.form.name = this.contact ? this.contact.name : null;
      this.form.email = this.contact ? this.contact.email : null;
      this.form.phone_number = this.contact ? this.contact.phone_number : null;
    },
    getEmptyFormValidation() {
      return {
        name: {
          state: null,
          feedback: null,
        },
        email: {
          state: null,
          feedback: null,
        },
        phone_number: {
          state: null,
          feedback: null,
        },
      };
    },
  },
  computed: {
    submitDisabled() {
      return !(this.form.name || this.form.email || this.form.phone_number);
    },
  },
  watch: {
    contact() {
      this.updateForm();
    },
  },
};
</script>

<style scoped></style>
